"use client";
import React from "react";

interface Props {
  text: string;
}

const CategoryDescriptionToggle = ({ text }: Props) => {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-6 mb-6 shadow-sm">
      <p
        className="text-slate-500 text-sm leading-relaxed"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {text}
      </p>
      <a
        href="#category-full-description"
        className="mt-2 inline-block text-[11px] font-black text-indigo-800 uppercase tracking-widest hover:text-blue-600 transition-colors no-underline"
      >
        See More
      </a>
    </div>
  );
};

export default CategoryDescriptionToggle;
